"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttestationResolver__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract IEAS",
                name: "eas",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AccessDenied",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidEAS",
        type: "error",
    },
    {
        inputs: [],
        name: "NotPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "OutOfBounds",
        type: "error",
    },
    {
        inputs: [],
        name: "VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "uid",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "time",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expirationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "revocationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "refUID",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "revocable",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct Attestation",
                name: "attestation",
                type: "tuple",
            },
        ],
        name: "attest",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "isPayable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "uid",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "time",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expirationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "revocationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "refUID",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "revocable",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct Attestation[]",
                name: "attestations",
                type: "tuple[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
        ],
        name: "multiAttest",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "uid",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "time",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expirationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "revocationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "refUID",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "revocable",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct Attestation[]",
                name: "attestations",
                type: "tuple[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
        ],
        name: "multiRevoke",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "uid",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "time",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expirationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "revocationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "refUID",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "revocable",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct Attestation",
                name: "attestation",
                type: "tuple",
            },
        ],
        name: "revoke",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "start",
                type: "uint256",
            },
        ],
        name: "toBytes32",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class AttestationResolver__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(eas, overrides) {
        return super.deploy(eas, overrides || {});
    }
    getDeployTransaction(eas, overrides) {
        return super.getDeployTransaction(eas, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.AttestationResolver__factory = AttestationResolver__factory;
//# sourceMappingURL=AttestationResolver__factory.js.map